module.exports = __webpack_public_path__ + "img/0.777dbfc6.png";